import React from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, Sun, Moon } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

const Header = () => {
  const navigate = useNavigate();
  const { isDarkMode, toggleTheme } = useTheme();

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user");
    navigate("/login");
  };

  return (
    <header
      className={`sticky top-6 z-40 rounded-xl px-5 py-3 flex items-center justify-between border backdrop-blur-sm transition-colors duration-300 ${
        isDarkMode
          ? "bg-black/80 border-zinc-800 text-white"
          : "bg-white/80 border-gray-200 text-gray-900 shadow-sm"
      }`}
    >
      <div className="flex items-center gap-3">
        <h1 className={`text-xl font-bold ${isDarkMode ? "text-orange-400" : "text-orange-600"}`}>
          SLAY
        </h1>
      </div>

      <div className="flex items-center gap-2">
        <button
          onClick={toggleTheme}
          className={`p-2 rounded-full transition-all duration-200 ${
            isDarkMode ? "hover:bg-zinc-800" : "hover:bg-gray-100"
          }`}
          title={isDarkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
        >
          {isDarkMode ? (
            <Sun size={22} className="text-orange-400" />
          ) : (
            <Moon size={22} className="text-gray-700" />
          )}
        </button>

        <button
          onClick={handleLogout}
          title="Logout"
          className={`flex items-center py-2 px-4 rounded-lg transition-all duration-200 ${
            isDarkMode
              ? "text-gray-400 hover:bg-red-900/50 hover:text-red-400"
              : "text-gray-600 hover:bg-red-100 hover:text-red-600"
          }`}
        >
          <LogOut size={18} />
          <span className="ml-2 text-sm font-medium">Logout</span>
        </button>
      </div>
    </header>
  );
};

export default Header;
